
import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";

@Component
export default class DocumentPersonalInfo extends Vue {
    @Prop({required: true})
    firstName!: string;
    @Prop({required: true})
    lastName!: string;
    @Prop({required: true})
    personalCode!: string;
    @Prop({required: true})
    birthDate!: Date;
    @Prop()
    photoUrl!: string | null;
    @Prop()
    signatureUrl!: string | null;
}
